import { useState } from "react";
import { apiPost } from "../lib/api";
import { Alert, Button, Field, Select, Textarea, Spinner } from "./ui";

// Keep in sync with REASONS in api/shared/reports.js
const REASONS = [
  { id: "not-gear", label: "Not soccer gear" },
  { id: "inappropriate", label: "Inappropriate or offensive" },
  { id: "spam", label: "Spam or a scam" },
  { id: "misleading", label: "Misleading or wrong details" },
  { id: "sold", label: "Already sold or unavailable" },
  { id: "other", label: "Something else" },
];

/* Collapsed to a quiet link by default. Reporting should be findable without
   being prominent — a big red button on every listing sets the wrong tone for
   a marketplace between families who know each other. */
export function ReportListing({ listingId }) {
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError("");
    if (!reason) return setError("Choose a reason.");
    setBusy(true);
    try {
      await apiPost("/reports", { listingId, reason, note: note.trim() });
      setDone(true);
    } catch (err) {
      setError(err.message || "Couldn't submit that report.");
    } finally {
      setBusy(false);
    }
  }

  if (done) {
    return (
      <div className="mt-6">
        <Alert kind="success">
          Thanks — Sartell Soccer has been notified and will take a look.
        </Alert>
      </div>
    );
  }

  if (!open) {
    return (
      <button
        onClick={() => setOpen(true)}
        className="mt-6 text-sm text-slate-400 hover:text-slate-600 underline"
      >
        Report this listing
      </button>
    );
  }

  return (
    <form onSubmit={submit} className="mt-6 rounded-lg border border-slate-200 bg-slate-50 p-3">
      <h3 className="font-semibold text-slate-700 text-sm">Report this listing</h3>
      <p className="mt-0.5 text-xs text-slate-500">
        This goes to the SSA admins. Nobody else sees it, and the seller isn't told who
        reported it.
      </p>
      <div className="mt-3 space-y-3">
        <Field label="Reason">
          <Select value={reason} onChange={(e) => setReason(e.target.value)}>
            <option value="">Choose…</option>
            {REASONS.map((r) => (
              <option key={r.id} value={r.id}>
                {r.label}
              </option>
            ))}
          </Select>
        </Field>
        <Field label="Anything else?" hint="Optional">
          <Textarea rows={2} value={note} onChange={(e) => setNote(e.target.value)} maxLength={1000} />
        </Field>
        <Alert>{error}</Alert>
        <div className="flex gap-2">
          <Button type="submit" disabled={busy}>
            {busy ? <Spinner /> : "Send report"}
          </Button>
          <Button type="button" variant="secondary" onClick={() => setOpen(false)} disabled={busy}>
            Cancel
          </Button>
        </div>
      </div>
    </form>
  );
}
